import React from 'react'

import * as S from './styled'

type PillsProps = {
  children: React.ReactNode
}

export const Pills = ({ children }: PillsProps) => {
  return <S.Container>{children}</S.Container>
}

type PillProps = {
  active: boolean
  label: string
  onClick: () => void
}

export const Pill = ({ active, label, onClick }: PillProps) => (
  <S.PillItem $active={active} onClick={onClick}>
    {label}
  </S.PillItem>
)

Pills.Pill = Pill
